export const asFormattedCurrency = (value: number | null | undefined, currency?: string | null) => `${value ?? '--'} ${currency || '€'}`
